/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, BoxProps } from "@chakra-ui/react";
import { Formik, FormikConfig, FormikValues } from "formik";
import React from "react";

export interface FormProps<Value extends FormikValues>
  extends Omit<FormikConfig<Value>, "children"> {
  children: React.ReactNode | React.ReactNode[];
  testId?: string;
  formProps?: BoxProps;
  apiError?: Record<string, unknown> | null;
}

function Form<Value extends FormikValues>({
  initialValues,
  onSubmit,
  children,
  validationSchema,
  formProps,
  apiError,
  testId,
  ...props
}: FormProps<Value>) {
  const childrenArray = React.Children.toArray(children);

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      {...props}
    >
      {({ handleSubmit, handleReset }) => (
        <Box
          as="form"
          {...formProps}
          data-testid={testId ?? "app-form"}
          onSubmit={handleSubmit}
          onReset={handleReset}
        >
          {childrenArray.map((child, index) => {
            if (React.isValidElement(child)) {
              return React.cloneElement(child as any, {
                key: index,
                apierror: apiError,
              });
            }
            return child;
          })}
        </Box>
      )}
    </Formik>
  );
}

export default Form;
